import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-admin-vendor',
  templateUrl: './admin-vendor.component.html',
  styleUrls: ['./admin-vendor.component.less'],
  providers: [SharedDataService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminVendorComponent {
  constructor(
    private SharedDataService: SharedDataService,
    private route: ActivatedRoute,
    private ToastService: ToastService,
    private Router: Router
  ) {
    const currentNavigation = this.Router.currentNavigation();

    if (currentNavigation) {
      const { extras } = currentNavigation;

      if (extras.state) {
        const { CompanyId } = extras.state;

        if (CompanyId) {
          this.CompanyId = CompanyId;
        }
      }
    }

    this.SharedDataService.listenForEvent().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'GetVendorId') {
          if (this.VendorId) {
            this.SharedDataService.sendEvent('SetVendorId', this.VendorId);
          }

          if (this.ExemptVendorId) {
            this.SharedDataService.sendEvent(
              'SetExemptVendorId',
              this.ExemptVendorId
            );
          }

          if (this.ClientRegisteredVendorId) {
            this.SharedDataService.sendEvent(
              'SetClientRegisteredVendorId',
              this.ClientRegisteredVendorId
            );
          }
        }

        if (eventName === 'SetTitle' && typeof data === 'string') {
          this.title = data;
        }

        if (eventName === 'GetCompanyId') {
          this.SharedDataService.sendEvent('SetCompanyId', this.CompanyId);
        }
      }
    });

    this.route.paramMap.subscribe({
      next: (ParamMap) => {
        const VendorId = ParamMap.get('VendorId');
        const ExemptVendorId = ParamMap.get('ExemptVendorId');
        const ClientRegisteredVendorId = ParamMap.get(
          'ClientRegisteredVendorId'
        );

        if (!VendorId && !ExemptVendorId && !ClientRegisteredVendorId) {
          this.ToastService.addErrorToast('Error', 'Missing Vendor Id.', {
            returnError: true
          });
        }

        this.VendorId = Number(VendorId);
        this.ExemptVendorId = Number(ExemptVendorId);
        this.ClientRegisteredVendorId = Number(ClientRegisteredVendorId);
      }
    });
  }

  title: string = '';
  VendorId?: number;
  ExemptVendorId?: number;
  ClientRegisteredVendorId?: number;
  CompanyId?: number;
}
